import React from 'react';

export interface Recommendation {
  name: string;
  company: string;
  image: string;
  text: string;
}

interface RecommendationCardProps {
  recommendation: Recommendation;
}

export const RecommendationCard: React.FC<RecommendationCardProps> = ({recommendation}) => (
  <section className="flex flex-col gap-3">
    <h2 className="text-zinc-900 text-2xl sm:text-3xl font-bold">Top Recommendation</h2>
    <div className="relative p-6 bg-blue-500 rounded-2xl text-white overflow-hidden min-h-[260px] shadow-sm gap-4">
      <p className="text-base sm:text-lg font-medium leading-relaxed mb-6">{recommendation.text}</p>
      <div className="bottom-4 left-5 flex items-center gap-4">
        <img src={recommendation.image} alt={recommendation.name} className="w-10 h-10 rounded-full" />
        <div>
          <div className="text-sm font-semibold">{recommendation.name}</div>
          <div className="text-xs opacity-80">{recommendation.company}</div>
        </div>
      </div>
    </div>
  </section>
);
